import { Link } from "react-router-dom";
import { useSEO } from "../lib/useSEO";
import { Dots } from "../components/motion/Reveal";

export default function NotFound() {
  useSEO("Page Not Found — Suvera Academy", "The page you are looking for does not exist.");
  return (
    <main className="hero-spotlight flex min-h-screen items-center" data-testid="not-found-page">
      <div className="mx-auto max-w-xl px-6 text-center">
        <Dots className="mb-6 justify-center" />
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-dot-amber">404</p>
        <h1 className="mt-4 font-display text-4xl font-semibold text-white sm:text-5xl">Page Not Found</h1>
        <p className="mt-4 text-white/60">The page you are looking for does not exist or has moved.</p>
        <Link to="/" className="mt-8 inline-flex rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-navy transition-colors duration-200 hover:bg-dot-amber" data-testid="not-found-home-link">
          Back to Home
        </Link>
      </div>
    </main>
  );
}
